'use strict';

var GridFillDownButtonDirective = function GridFillDownButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-fill-down-button.html'),
    controller: 'GridFillDownButtonController'
  };
};
GridFillDownButtonDirective.$inject = [];
module.exports = GridFillDownButtonDirective;